import React from "react";
import "./Signature.scss";
import SignaturePad from "react-signature-canvas";
import { useRef } from "react";
import { Button, SvgIcon } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadBtn from "../download/DownloadBtn";
import { ReactComponent as Upload } from "../../../../assets/images/Upload-Red.svg";
import ImageIcon from '@mui/icons-material/Image';
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadDoc,
  uploadSignedDoc,
} from "../../../../redux/actions/dataActions";
import { useEffect } from "react";
const Signature = () => {
  const dispatch = useDispatch();
  const { data, current_doc, signature_sent, signature_error } = useSelector((state) => state.data);
  const fileInput = useRef(null);
  const [file, setFile] = useState(null);
  const [signed, setSigned] = useState(false);
  const [noFile, setNoFile] = useState(false);
  let sigPad = {}; 

  const clear = () => {
    sigPad.clear();
  };

  const saveSign = async () => {

    let sign = await sigPad.getTrimmedCanvas().toDataURL("image/png");
    let signed = !sigPad._sigPad._isEmpty;

    // check that signature is full and file is loade if needed
    if (signed && ((IsCompany() && file) || !IsCompany())) {
      let stamp=''
      if(file){
         stamp = await readFileAsync();
      }
     
      dispatch(
        uploadSignedDoc({
          DocType: current_doc?.documentType,
          CalcCode: data?.id,
          File: sign,
          Stamp: stamp || "",
        })
      );
      setSigned(true);
    } else if (signed) {
      setNoFile(true);
    }
    
  };

  const readFileAsync = () => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    setFile(fileUploaded);
  };
  const IsCompany = () => {
    return data.customerName.includes('בע"מ');
  };

  return (
    !signed ? 
    <div className="sign_form">
      <DownloadBtn link={current_doc?.url} label={` לצפייה ב${current_doc?.label}`} />
      <div>
        <div className="sign_actions">
          <div className="sign_note">חתום עם העכבר באזור המסומן</div>
          <Button
            className="clear_btn"
            onClick={() => {
              clear();
            }}
          >
            <CloseIcon className="clear_icon" />
            <span>נקה חתימה</span>
          </Button>
        </div>
        <SignaturePad
          canvasProps={{ className: "sign_canvas" }}
          ref={(ref) => {
            sigPad = ref;
          }}
        />
      </div>
      {IsCompany() && (
        <div className="company_sign">
          <div>במידה והמזמין חברה בע״מ, יש לצרף בנוסף חותמת חברה</div>
          <input
            className="uploadFile"
            onChange={handleChange}
            ref={fileInput}
            type={"file"}
          ></input>
          <Button onClick={() => fileInput.current.click()} variant="outlined">
            <SvgIcon className="upload_icon" component={Upload}></SvgIcon>
            העלה קובץ
          </Button>
          {noFile &&
            <div className="red-notice">נא להעלות חותמת חברה</div>
          }
          <div>{file?.name}</div>
        </div>
      )}

      <Button
        className="submit_btn"
        variant="outlined"
        onClick={() => saveSign()}
      >
        שמירה
      </Button>
    </div> : (signature_sent.some(item => item.type === current_doc.documentType) ?
    <div className="sign_form">
      הטופס נחתם בהצלחה
    </div> : (signature_error ?
    <div className="sign_form">
    החתימה לא נקלטה במערכת. יש לחתום בשנית
    </div> : 
    <div className="sign_form">טוען.....</div>))
    
  );
};

export default Signature;
